import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/utils/axios';

export const useEnderecoStore = defineStore('endereco', () => {
  // State
  const loading = ref(false);
  const error = ref(null);

  /**
   * Buscar endereço por CEP
   * @param {string} cep - O CEP a ser consultado
   */
  const buscarEnderecoPorCep = async (cep) => {
    // Remover caracteres não numéricos do CEP
    const cepLimpo = cep.replace(/\D/g, '');
    
    // Verificar se o CEP tem pelo menos 8 dígitos
    if (cep.length < 9) {
      return { 
        success: false,
        message: 'CEP inválido' 
      };
    }
    
    loading.value = true;
    error.value = null;
    
    try {
      const response = await useApi(`/enderecos/cep/${cep}`).fetch();
      
      if (response && response.status === 'success' && response.data) {
        return {
          success: true,
          data: response.data
        };
      } else {
        throw new Error(response?.message || 'Erro ao buscar endereço');
      }
    } catch (err) {
      error.value = err.message || 'Erro ao buscar endereço';
      return {
        success: false,
        message: err.message || 'Erro ao buscar endereço'
      };
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    error,
    buscarEnderecoPorCep
  };
});
